import * as React from 'react'
// libs
import he from 'he'
// types
import { Editor } from '@tiptap/react'
// icons
import CodeIcon from '@mui/icons-material/Code'
import SaveIcon from '@mui/icons-material/Save'
// views
import { Button, ButtonWrapper, SaveButton } from './views'

interface Props {
  onExit: () => void
  editorRef: React.MutableRefObject<Editor | null>
  isActive: boolean
  toggleIsActive: (value: boolean) => void
}


const SourceButton: React.FC<Props> = ({ onExit, editorRef, isActive, toggleIsActive }) => {
  const exitSourceMode = () => {
    const editor = editorRef.current

    if (!editor) return

    const codeEl = editor.view.dom.querySelector('code')
    const escaped = codeEl ? (codeEl.textContent ?? '') : editor.getText()

    editor.commands.setContent(he.decode(escaped))
    toggleIsActive(false)
  }

  const handleClick = () => {
    const editor = editorRef.current

    if (!editor) return

    if (!isActive) {
      const html = editor.getHTML()

      editor.commands.setContent('<pre><code>' + he.encode(html) + '</code></pre>')
      toggleIsActive(true)
    } else {
      onExit()
      toggleIsActive(false)
    }
  }

  return (
    <ButtonWrapper isActive={!isActive}>
      <Button isActive={isActive} onClick={handleClick} title='Source'>
        <CodeIcon style={{ fontSize: 16 }} />
      </Button>
      {isActive && (
        <SaveButton onClick={exitSourceMode} title='Save'>
          <SaveIcon style={{ fontSize: 16 }} />
        </SaveButton>
      )}
    </ButtonWrapper>
  )
}

export default SourceButton
